import { useMemo } from "react"

import { ProductImage } from "scrivito/Objs/Product/Components/ProductImage"
import { ProductObj } from "scrivito/Objs/Product/ProductObjClass"
import { Maybe } from "shared/types/Maybe"
import { ProductConfigurationFormData } from "shared/types/ProductConfiguration"
import { ProductConfiguratorAddonOption } from "shared/types/ProductConfigurator"
import { RJSFSchema } from "shared/types/RJSF"

import { useProductConfigurationAddons } from "./useProductConfigurationAddons"

interface UseProductConfigurationAddonOptionsProps {
  addons: RJSFSchema | undefined | null
  addonVariantKeys: string[] | null | undefined
  loadingFieldID?: string | null | undefined
  formData?: Maybe<ProductConfigurationFormData["addons"]>
  productObj?: ProductObj | null | undefined
}

export function useProductConfigurationAddonOptions(
  props: UseProductConfigurationAddonOptionsProps
): ProductConfiguratorAddonOption[] {
  const { productObj } = props
  const scrivitoAddons = productObj?.get("addons")

  const transformedAddons = useProductConfigurationAddons(props)

  const options: ProductConfiguratorAddonOption[] = useMemo(
    () =>
      transformedAddons
        .map(
          addon =>
            ({
              key: addon.key,
              title:
                addon.schema?.properties?.value.title ||
                addon.baseVariant?.get("title") ||
                addon.obj?.get("title") ||
                "",
              payload: {
                ...addon,
                id: addon.key,
                description:
                  addon.baseVariant?.get("description") ||
                  addon.obj?.get("description"),
                image: <ProductImage obj={addon.baseVariant || addon.obj} />
              }
            } as ProductConfiguratorAddonOption)
        )
        .filter(Boolean) as ProductConfiguratorAddonOption[],
    [transformedAddons, scrivitoAddons]
  )

  return options
}
